import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { gmailIntegrationsQuery } from "modules/settings/lib/gmail/gmailIntegrationsQuery"
import {
  DataResponse,
  GmailIntegrationCallbackSchema,
  GmailIntegrationsResponseDataSchema,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GmailIntegrationsResponseDataSchema>>

export function useCreateGmailIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof GmailIntegrationCallbackSchema>) => {
      const response = await axios.post<Response>(`/integrations/gmail/auth`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: gmailIntegrationsQuery().queryKey })
    },
  })
}
